import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { TypeOfIndebtednessInsertService } from '../../service/type-of-indebtedness-insert/type-of-indebtedness-insert.service';

@Component({
	selector: 'app-type-of-indebtedness-insert',
	templateUrl: './type-of-indebtedness-insert.component.html',
	providers: [
		TypeOfIndebtednessInsertService,
		HttpModule
	]

})
export class TypeOfIndebtednessInsertComponent implements OnInit {
	indebtedness: FormGroup;
	Nome: string = "";
	private token;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private typeOfIndebtednessInsertService: TypeOfIndebtednessInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.indebtedness = fb.group({
			'Tipo': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	insertIndebtedness(value: any) {
		this.typeOfIndebtednessInsertService.insertIndebtedness(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Tipo de Endividamento cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/tipo-endividamento');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});

	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-endividamento');
	}

}



// WEBPACK FOOTER //
// ./src/app/type-of-indebtedness/component/type-of-indebtedness-insert/type-of-indebtedness-insert.component.ts